import { connect } from "react-redux";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import A5ScreeningDetails from "@/components/Common/A5ScreeningDetails";
import A5ScreeningList from "@/components/Common/A5ScreeningList";
import AddAppointment from "@/components/Provider/ScheduleAvailability/AddAppointment";
import { admin_admin, admin_bp, admin_cse, adminRoute, baseRoute } from "@/config/roles";
import { AdvancedCareActivityNewForm } from "@/components/Provider/PatientView/MemberProfile/AdvancedCareActivity/AdvancedCareActivityNewForm";
import { canCreateAdvancedCareActivityNotes } from "@/features/acp/helpers/note-creation";
import ChangePassword from "@/components/Authentication/ChangePassword";
import DischargeData from "@/components/Provider/PatientView/MemberProfile/DischargeData";
import DraftNotesTable from "@/components/Provider/DraftNotes";
import { Footer } from "@/component-library/Footer";
import { FullNoteView } from "@/features/notes/(note-views)/FullNoteView";
import GAD7 from "@/features/assessments/GAD7";
import { getAdminProfile, isAuthorized } from "@/redux/actions/auth";
import InsuranceEligibilityQueueManagement from "@/components/Admin/InsuranceEligibilityQueueManagement/InsuranceEligibilityQueueManagement";
import InsuranceEligibilityRecordManagement from "@/components/Admin/InsuranceEligibilityRecordManagement";
import { Main2 } from "@/components/layout/Main";
import { MemberProfile } from "@/features/member-profile/MemberProfile";
import NewNote from "@/features/notes/NewNote";
import PHQ9 from "@/features/assessments/PHQ9";
import { PrintNoteView } from "@/features/notes/(note-views)/PrintNoteView";
import PrivacyPolicy from "@/components/Common/PrivacyPolicy";
import Profile from "@/components/Provider/Profile/Profile";
import { Toolbar } from "@/components/Navigation/Toolbar/Toolbar";
import TutorialScreens from "@/components/Common/TutorialScreen";
import { ViewDraftNote } from "@/features/notes/(note-views)/DraftNoteView";
import ViewDraftNoteV2 from "@/features/notes/(note-views)/DraftNoteViewV2";
import ViewNote from "@/features/notes/ViewNote";
import { WaitlistForm } from "@/components/Common/WaitlistForm/WaitlistForm";

import A5Report from "../Providers/A5Report";
import CareTeamList from "../Providers/PatientProfileView/CareTeamList";
import ClinicalAssessment from "../Providers/PatientProfileView/ClinicalAssessment";
import FileList from "../Providers/FileList";
import IBARReport from "../Providers/IBARReport";
import IPSRReport from "../Providers/IPSRReport";
import mapLabelToComponent from "../common/mapLabelToComponent";
import NewReport from "../Providers/NewReport";
import OBARReport from "../Providers/OBARReport";
import OnBehalfOfSchedule from "../Providers/OnBehalfOfSchedule";
import OPSRReport from "../Providers/OPSRReport";
import Patient from "../Providers/Patient";
import PatientsList from "../Providers/PatientsList/PatientsList";
import ProgressNoteList from "../Providers/PatientProfileView/ProgressNoteList";
import Ratings from "../Providers/PatientProfileView/Ratings";
import ReferralView from "../Providers/ReferralView";
import Reports from "../Providers/Reports";
// eslint-disable-next-line import-x/no-named-as-default
import SchedulePageV2 from "../Providers/SchedulePageV2";
import Settings from "../common/SettingsPage";
import WorkingHours from "../Providers/WorkingHours";

import AdminProfile from "./AdminProfile";
import CustomerSuccessManagerList from "./CustomerSuccessManagerList";
import NewPractice from "./NewPractice";
import NewProvider from "./NewProvider";
import OmnisearchList from "./OmnisearchList";
import Practice from "./Practice";
import PracticeList from "./PracticeList";
import Provider from "./Provider";

class AdminRouter extends Component {
  DEFAULT_ROUTE_SECTION_OPTIONS = [
    {
      icon: "NavMenu__practices-icon",
      label: "Practices",
      mobileIcon: "practices.svg",
      route: adminRoute + "/practice",
    },
    {
      icon: "NavMenu__screening-icon",
      label: "Screening",
      mobileIcon: "screening.svg",
      route: adminRoute + "/a5_screenings",
    },
    {
      icon: "NavMenu__reports-icon",
      label: "Reports",
      mobileIcon: "reports.svg",
      route: adminRoute + "/reports",
    },
    {
      icon: "NavMenu__settings-icon",
      label: "Settings",
      mobileIcon: "settings.svg",
      route: adminRoute + "/settings",
    },
  ];

  ADMIN_OR_CSE_ROUTE_SECTION_OPTIONS = [
    {
      activeIconComponent: mapLabelToComponent("Practices", true),
      icon: "NavMenu__practices-icon",
      iconComponent: mapLabelToComponent("Practices", false),
      label: "Practices",
      mobileIcon: "practices.svg",
      route: adminRoute + "/practice",
    },
    {
      activeIconComponent: mapLabelToComponent("Screening", true),
      icon: "NavMenu__screening-icon",
      iconComponent: mapLabelToComponent("Screening", false),
      label: "Screening",
      mobileIcon: "screening.svg",
      route: adminRoute + "/a5_screenings",
    },
    {
      activeIconComponent: mapLabelToComponent("Customer Success", true),
      icon: "NavMenu__patients-icon",
      iconComponent: mapLabelToComponent("Customer Success", false),
      label: "Customer Success",
      mobileIcon: "customer_success.svg",
      route: adminRoute + "/customer_success",
    },
    {
      icon: "NavMenu__settings-icon",
      label: "Add New Practice",
      mobileIcon: "add_new.svg",
      mobileOnly: true,
      route: adminRoute + "/practice/add",
    },
    {
      activeIconComponent: mapLabelToComponent("Reports", true),
      icon: "NavMenu__reports-icon",
      iconComponent: mapLabelToComponent("Reports", false),
      label: "Reports",
      mobileIcon: "reports.svg",
      route: adminRoute + "/reports",
    },
    {
      activeIconComponent: mapLabelToComponent("Eligibility", true),
      icon: "NavMenu__eligibility-icon",
      iconComponent: mapLabelToComponent("Eligibility", false),
      label: "Eligibility",
      mobileIcon: "eligibility-icon-navy.svg",
      route: adminRoute + "/eligibility",
    },
    {
      iconComponent: mapLabelToComponent("Search", false),
      label: "Search",
      route: adminRoute + "/search",
    },
  ];

  BILLING_PARTNER_ROUTE_SECTION_OPTIONS = [
    {
      icon: "NavMenu__reports-icon",
      label: "Reports",
      mobileIcon: "reports.svg",
      route: adminRoute + "/reports",
    },
    {
      icon: "NavMenu__settings-icon",
      label: "Settings",
      mobileIcon: "settings.svg",
      route: adminRoute + "/settings",
    },
    {
      iconComponent: mapLabelToComponent("Search", false),
      label: "Search",
      route: adminRoute + "/search",
    },
  ];

  get_route_section_options() {
    if (isAuthorized(admin_cse) || isAuthorized(admin_admin)) {
      return this.ADMIN_OR_CSE_ROUTE_SECTION_OPTIONS;
    } else if (isAuthorized(admin_bp)) {
      return this.BILLING_PARTNER_ROUTE_SECTION_OPTIONS;
    }

    return this.DEFAULT_ROUTE_SECTION_OPTIONS;
  }

  ROUTE_SECTION_OPTIONS = this.get_route_section_options();

  ADMIN_BASE_REDIRECT_ROUTE = isAuthorized(admin_bp)
    ? `${adminRoute}/reports`
    : `${adminRoute}/practice`;

  navbarConfiguration = {
    customRenderSection: [],
    routeSection: {
      options: this.ROUTE_SECTION_OPTIONS,
    },
    selfSection: {},
  };

  componentDidMount() {
    this.props.getAdminProfile();
  }

  render() {
    return (
      <>
        <Toolbar
          baseRoute={baseRoute}
          dynamicRouteConfig={{}}
          enableSearch={true}
          navbarConfiguration={this.navbarConfiguration}
        />

        <Main2>
          <Switch>
            {isAuthorized(admin_cse) && (
              <Route
                component={WaitlistForm}
                path={adminRoute + "/patient/:patientId/waitlist_form"}
              />
            )}
            <Route
              path={adminRoute + "/settings"}
              render={() => <Settings baseRoute={adminRoute} />}
            />
            <Route
              path={adminRoute + "/schedule/:providerId/view"}
              render={(props) => <SchedulePageV2 {...props} />}
            />
            <Route component={AddAppointment} path={adminRoute + "/schedule/:providerId/add"} />
            <Route component={OnBehalfOfSchedule} path={adminRoute + "/schedule/:providerId"} />
            <Route
              path={adminRoute + "/profile/hours/:providerId"}
              render={(props) => <WorkingHours {...props} baseRoute={adminRoute} />}
            />
            <Route
              path={adminRoute + "/profile/:providerId"}
              render={(props) => <Profile {...props} baseRoute={adminRoute} />}
            />
            <Route component={AdminProfile} path={adminRoute + "/profile"} />
            <Route component={NewReport} path={adminRoute + "/reports/add"} />
            <Route
              path={adminRoute + "/reports"}
              render={(props) => <Reports {...props} baseRoute={adminRoute} />}
            />
            <Route
              path={adminRoute + "/privacy-policy"}
              render={() => <PrivacyPolicy baseRoute={adminRoute} />}
            />
            <Route
              path={adminRoute + "/tutorial"}
              render={() => <TutorialScreens baseRoute={adminRoute} />}
            />
            <Route
              path={adminRoute + "/change-password"}
              render={(props) => <ChangePassword {...props} baseRoute={adminRoute} />}
            />
            <Route component={NewPractice} path={adminRoute + "/practice/add"} />
            <Route
              path={adminRoute + "/practice/:practiceId/provider/add"}
              render={(props) => <NewProvider {...props} baseRoute={adminRoute} />}
            />
            <Route
              path={adminRoute + "/practice/:practiceId/provider/:providerId/patientsList"}
              render={(props) => (
                <PatientsList
                  practiceId={props.match.practiceId}
                  providerId={props.match.providerId}
                  {...props}
                  baseRoute={adminRoute}
                />
              )}
            />
            <Route
              path={adminRoute + "/practice/:practiceId/provider/:providerId"}
              render={(props) => <Provider {...props} baseRoute={adminRoute} />}
            />
            <Route
              path={adminRoute + "/practice/:practiceId"}
              render={(props) => <Practice {...props} baseRoute={adminRoute} />}
            />
            <Route
              path={adminRoute + "/practice"}
              render={(props) => <PracticeList {...props} baseRoute={adminRoute} />}
            />
            <Route
              path={adminRoute + "/search"}
              render={(props) => <OmnisearchList {...props} baseRoute={adminRoute} />}
            />
            <Route
              path={adminRoute + "/patient/:patientId/file"}
              render={(props) => <FileList {...props} type="patient" />}
            />
            <Route component={NewNote} path={adminRoute + "/patient/:patientId/note/add"} />
            <Route
              component={ViewDraftNoteV2}
              path={adminRoute + "/patient/:patientId/note/:noteId/v2/draft"}
            />
            <Route
              component={ViewDraftNote}
              path={adminRoute + "/patient/:patientId/note/:noteId/draft"}
            />
            <Route
              component={PrintNoteView}
              path={adminRoute + "/patient/:patientId/export_notes"}
            />
            <Route
              component={FullNoteView}
              path={adminRoute + "/patient/:patientId/note/:noteId/v2"}
            />
            <Route component={ViewNote} path={adminRoute + "/patient/:patientId/note/:noteId"} />
            <Route component={ProgressNoteList} path={adminRoute + "/patient/:patientId/note"} />
            {canCreateAdvancedCareActivityNotes() && (
              <Route
                component={AdvancedCareActivityNewForm}
                path={adminRoute + "/patient/:patientId/advanced_care_activity"}
              />
            )}
            <Route
              component={ClinicalAssessment}
              path={adminRoute + "/patient/:patientId/clinical_assessment"}
            />
            <Route component={MemberProfile} path={adminRoute + "/patient/:patientId/profile/v2"} />
            <Route component={CareTeamList} path={adminRoute + "/patient/:patientId/care_team"} />
            <Route component={A5Report} path={adminRoute + "/patient/:patientId/report/a5"} />
            <Route component={IBARReport} path={adminRoute + "/patient/:patientId/report/ibar"} />
            <Route component={IPSRReport} path={adminRoute + "/patient/:patientId/report/ipsr"} />
            <Route component={OBARReport} path={adminRoute + "/patient/:patientId/report/obar"} />
            <Route component={OPSRReport} path={adminRoute + "/patient/:patientId/report/opsr"} />
            <Route component={Ratings} path={adminRoute + "/patient/:patientId/ratings"} />
            <Route component={PHQ9} path={adminRoute + "/patient/:patientId/phq-9"} />
            <Route component={GAD7} path={adminRoute + "/patient/:patientId/gad-7"} />
            <Route component={Reports} path={adminRoute + "/patient/:patientId/report"} />
            <Route
              component={DischargeData}
              path={adminRoute + "/patient/:patientId/discharge/:dischargeId"}
            />
            <Route component={Patient} path={adminRoute + "/patient/:patientId"} />
            {(isAuthorized(admin_cse) || isAuthorized(admin_admin)) && (
              <Route
                component={CustomerSuccessManagerList}
                path={adminRoute + "/customer_success"}
              />
            )}
            <Route
              path={adminRoute + "/a5_screenings/:screening_id/file"}
              render={(props) => <FileList {...props} type="a5_screenings" />}
            />
            <Route
              component={A5ScreeningDetails}
              path={adminRoute + "/a5_screenings/:screening_id"}
            />
            <Route component={A5ScreeningList} path={adminRoute + "/a5_screenings"} />
            <Route
              path={adminRoute + "/referral/:referralCode/file"}
              render={(props) => <FileList {...props} type="referral" />}
            />
            <Route component={ReferralView} path={adminRoute + "/referral/:referralCode"} />
            <Route component={DraftNotesTable} path={adminRoute + "/draft-notes/:providerId"} />
            {(isAuthorized(admin_cse) || isAuthorized(admin_admin)) && (
              <Route
                component={InsuranceEligibilityRecordManagement}
                path={adminRoute + "/eligibility/:id"}
              />
            )}
            {(isAuthorized(admin_cse) || isAuthorized(admin_admin)) && (
              <Route
                component={InsuranceEligibilityQueueManagement}
                path={adminRoute + "/eligibility"}
              />
            )}
            <Redirect from={adminRoute} to={this.ADMIN_BASE_REDIRECT_ROUTE} />
          </Switch>
        </Main2>

        <Footer />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    profile: state.auth.profile,
  };
};

AdminRouter.propTypes = {
  getAdminProfile: PropTypes.func,
  history: PropTypes.object,
  profile: PropTypes.object,
  url: PropTypes.string,
};

export default connect(mapStateToProps, { getAdminProfile })(AdminRouter);
